import { combineReducers } from "redux"
import users from "./reducer_users"
import auth from "./reducer_auth"
import permissions from "./reducer_permissions"
import participantData from "./reducer_participant_data"
import { MEDICATIONS, FILTERED_MEDICATIONS } from "../actions/medications"
import { AUTH } from "../actions/auth"
import { SEARCH_TEXT } from "../actions/search"

const createReducer = (actionType, initialState) => (state = initialState, action) => {
  switch(action.type){
  case actionType:
    return action.payload
  default:
    return state
  }
}

const reducersDefaultValues = {
  treatedMissingFoods: null,
  missingFoods: null, 
  filteredFoods: null,
  [FILTERED_MEDICATIONS]: null,
  [MEDICATIONS]: null,
  [SEARCH_TEXT]: "",
  isBloodTestsFeedbackModalOpen: false,
  call: null,
  selectedCallTab: null,
  inAction: false,
  labVisitResearchStage: null,
  participant: null,
  signupCohort: null,
  callCenterTab: "",
  supportTab: "",
  receiveDataAndSupportTab: "",
  supportFilters: {},
}

const reducers = {}
Object.entries(reducersDefaultValues).map(([key, defaultValue]) => {
  reducers[key] = createReducer(key, defaultValue)
})

const appReducer = combineReducers({
  users,
  auth,
  permissions,
  participantData,
  ...reducers
})

const rootReducer = (state, action) => {
  if (action.type === "RESET_STORE" || action.type === AUTH && !action.payload) {
    state = { [MEDICATIONS]: state[MEDICATIONS] }
  }

  return appReducer(state, action)
}

export default rootReducer
